import React, { useEffect, useReducer, useState } from "react";
import TablePagination from '@material-ui/core/TablePagination';
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Multiselect from 'multiselect-react-dropdown';

import {
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import Title from "../../components/Title";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  customTableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const reducer = (state, action) => {
    if (action.type === "LOAD_MESSAGES") {
        const messages = action.payload;
        const newMessages = [];
    
        messages.forEach((message) => {
        const messageIndex = state.findIndex((m) => m.id === message.id);
        if (messageIndex !== -1) {
            state[messageIndex] = message;
        } else {
            newMessages.push(message);
        }
        });
    
        return [...newMessages, ...state];
    }
    
    if (action.type === "ADD_MESSAGE") {
        const newMessage = action.payload;
        const messageIndex = state.findIndex((m) => m.id === newMessage.id);
    
        if (messageIndex !== -1) {
        state[messageIndex] = newMessage;
        } else {
        state.push(newMessage);
        }
    
        return [...state];
    }

    if (action.type === "RESET") {
      return [];
    }
};

const Histories = () => {
    const options = [{name: 'Bot', id: "bot"},{name: 'Waba', id: "waba"},{name: 'Telegram', id: "telegram"},{name: 'SMS', id: "sms"}]
    const classes = useStyles();

    const [messagesList, dispatch] = useReducer(reducer, []);
    const [searchParam, setSearchParam] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [typeFilter, setTypeFilter] = useState([]);
    const [dataCount, setDataCount] = useState(false);
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      dispatch({ type: "RESET" });
      setPageNumber(0);
    }, [searchParam]);
  
    useEffect(() => {
      setLoading(true);
      const delayDebounceFn = setTimeout(() => {
        const fetchMessages = async () => {
          try {
            const { data } = await api.get("/sentmessages", {
              params: { searchParam, rowsPerPage, pageNumber: pageNumber+1, typeFilter: typeFilter.map(u => u.id).join(',') },
            });
  
            dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
            setDataCount(data.count);
            setLoading(false);
          } catch (err) {
            setLoading(false);
            toastError(err);
          }
        };
        fetchMessages();
      }, 500);
      return () => {
        clearTimeout(delayDebounceFn);
      };
    }, [searchParam, rowsPerPage, pageNumber, typeFilter]);

    const handleSearch = (event) => {
      setSearchParam(event.target.value.toLowerCase());
    };

    const handleChangePage = (event, newPage) => {
        dispatch({ type: "RESET" });
        setPageNumber(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        dispatch({ type: "RESET" });
        setRowsPerPage(parseInt(event.target.value, 10));
        setPageNumber(0);
    };

    const onUpdateTypeFilter = (selectedList, selectedItem) => {
      dispatch({ type: "RESET" });
      setTypeFilter(selectedList)
    }

  return (
    <MainContainer>
      <MainHeader>
        <Title>{i18n.t("sentMessages.title")}</Title>
        <MainHeaderButtonsWrapper>
          <TextField
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
        </MainHeaderButtonsWrapper>
        <Multiselect
          options={options}
          selectedValues={typeFilter}
          onSelect={onUpdateTypeFilter}
          onRemove={onUpdateTypeFilter}
          placeholder="Type Filter"
          displayValue="name"
        />
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                {i18n.t("sentMessages.table.type")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("sentMessages.table.templateName")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("sentMessages.table.destination")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("sentMessages.table.message")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("sentMessages.table.sent")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {messagesList.map((message) => (
                <TableRow key={message.id}>
                  <TableCell align="center">{message.type}</TableCell>
                  <TableCell align="center">{message.templateName}</TableCell>
                  <TableCell align="center">{message.destination}</TableCell>
                  <TableCell align="center">
                    <div className={classes.customTableCell}>
                      <Typography
                        style={{ width: 300, align: "center" }}
                        noWrap
                        variant="body2"
                      >
                        {message.content}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell align="center">{message.createdAt}</TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton columns={4} />}
            </>
          </TableBody>
        </Table>
        <TablePagination
            component="div"
            count={dataCount}
            page={pageNumber}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            />
      </Paper>
    </MainContainer>
  );
};

export default Histories;
